"use client";
import Image from "next/image";
import Link from "next/link";

export const Logo = () => {
  return (
    <Link href="/" className="flex items-center mr-4 relative z-20">
      <Image
        src="/coldfire-logo.png"
        alt="Coldfire"
        width={180}
        height={40}
        priority
        className="h-7 w-auto"
      />
    </Link>
  );
};
